import React from "react";
import { Box, Text, useBreakpoint } from "@chakra-ui/react";
import { keyframes } from "@emotion/react";
import { getDuration } from "../../utils";
import { TbDeviceImacCode } from "react-icons/tb";

const SmallerTimeLine = ({ start_date, end_date, role }) => {
  const rotateIn = keyframes`0%{
        opacity:0;
        transform:rotate3d(0,0,1,-200deg);
    }
    100%{
        opacity:1;
        transform:rotate3d(0,0,0);
    }
    `;
  return (
    <Box display="flex" alignItems="center" gap={4} ml="2">
      <Box
        fontSize="1.75rem"
        color={"rgb(94,234,212)"}
        bg="#000"
        animation={`${rotateIn} 1s linear`}
        display={{ base: "block", smm: "none" }}
      >
        <TbDeviceImacCode />
      </Box>
      <Box>
        <Text color="rgb(226,232,240)" lineHeight="1.9" fontSize="1.25rem">
          {getDuration(start_date, end_date)}
        </Text>
        <Text
          color={"rgb(203,213,225)"}
          lineHeight="1.25rem"
          fontSize="1.15rem"
        >
          {role}
        </Text>
      </Box>
    </Box>
  );
};

export default SmallerTimeLine;
